import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from '@saleshandy/icons';
import Banner, { BannerVariant } from '../../../../../../../shared/design-system/components/atoms/banner/banner';
import { EmailServiceProvider } from '../../../../../enums/email-account';



const UnifiedHardLimitBanner = ({
  show,
  hardLimit,
  onConnectAnotherEmailAccount,
  emailServiceProvider,
}) => {
  const { t } = useTranslation();

  if (!show) return null;

  let providerName = emailServiceProvider as string;
  if (emailServiceProvider === EmailServiceProvider.Gsuite) {
    providerName = EmailServiceProvider.Gmail;
  } else if (emailServiceProvider === EmailServiceProvider.Microsoft) {
    providerName = 'Outlook';
  } else if (emailServiceProvider === EmailServiceProvider.O365) {
    providerName = EmailServiceProvider.Microsoft;
  }

  const isOther = emailServiceProvider === EmailServiceProvider.Other;

  const messageContent = (
    <span>
      {t('messages.unified_hard_limit_intro')}
      {isOther ? (
        <>
          {t('messages.unified_hard_limit_deliverability')} {hardLimit}
          {t('messages.unified_hard_limit_emails_per_day')}
        </>
      ) : (
        <>
          <span className="text-caplitalize">{providerName} </span>
          {t('messages.unified_hard_limit_provider_block')} {hardLimit}
          {t('messages.unified_hard_limit_emails_per_day')}
        </>
      )}
      <br />
      {t('messages.unified_hard_limit_we_recommend')}
      <button
        type="button"
        className="unified-hard-limit-banner__link"
        onClick={onConnectAnotherEmailAccount}
      >
        {t('messages.unified_hard_limit_connect_account')}
      </button>
      {t('messages.unified_hard_limit_to_send_more')}
    </span>
  );

  return (
    <Banner
      pageHeaderBannerMessage=" "
      variant={BannerVariant.Warning}
      isIconShow
      Icon={<AlertCircle color="#D97706" />}
      className="unified-hard-limit-banner"
      customBannerClass="unified-hard-limit-banner__inner"
    >
      {messageContent}
    </Banner>
  );
};

export default UnifiedHardLimitBanner;
